export const sortAscendingByOptionTitle = ( a, b ) => {
    if ( typeof a.title === 'undefined' || typeof b.title === 'undefined' || !a.title || !b.title ) {
        return 0;
    }
    if ( a.title.toLocaleLowerCase() < b.title.toLocaleLowerCase() ) { return -1; }
    if ( a.title.toLocaleLowerCase() > b.title.toLocaleLowerCase() ) { return 1; }
    return 0;
};
